//*************************************************************************************
//* Session specific code
//*
//* 6/13/18 Kraus    [COM-136]: Created
//*************************************************************************************

app.Individual = (function () {
    var myIndividual = {
        Index: function () {

            $("#gridIndividual").kendoGrid(
                {
                    columns: [
                        {
                            field: "UserId",
                            hidden: true
                        },
                        {
                            title: 'Select All',
                            headerTemplate: "<div class='text-center'>To<br/>Select All<br/><input type='checkbox' data-role='select-all' /></div>",
                            template: "<div class='text-center'><input type='hidden' name='UserIds.Index' value='#= UserId #' /><input type='checkbox' #= Checked # name='UserIds[#= UserId #]' value='#= UserId #' /></div>"
                        },
                        {
                            title: 'Select All',
                            headerTemplate: "<div class='text-center'>CC<br/>Select All<br/><input type='checkbox' data-role='select-all' /></div>",
                            template: "<div class='text-center'><input type='hidden' name='CcUserIds.Index' value='#= UserId #' /><input type='checkbox' #= CcChecked # name='CcUserIds[#= UserId #]' value='#= UserId #' /></div>"
                        },
                        {
                            title: 'Select All',
                            headerTemplate: "<div class='text-center'>BCC<br/>Select All<br/><input type='checkbox' data-role='select-all' /></div>",
                            template: "<div class='text-center'><input type='hidden' name='BccUserIds.Index' value='#= UserId #' /><input type='checkbox' #= BccChecked # name='BccUserIds[#= UserId #]' value='#= UserId #' /></div>"
                        },
                        {
                            field: "FirstName",
                            title: "First Name"
                        },
                        {
                            field: "LastName",
                            title: "Last Name"
                        },
                        {
                            field: "NetId",
                            title: "NetID"
                        },
                        {
                            field: "Committees",
                            title: "Committee"
                        },
                        {
                            template: "<a target='_blank' class='uw-button tiny info remove-rounded-corners' href='/Individuals/Details/#=UserId#'>Details</a>"
                        }],
                    scrollable: false,
                    sortable: true,
                    columnMenu: true,
                    groupable: {
                        messages: {
                            empty: "Drop columns here to group by"
                        }
                    }
                });
            app.KendoGrids.InitPersistentGrid("gridIndividual", false);

            $(document).on("kendo-datasource-load-complete", function () {
                app.Individual.EvaluateSelectAllCheckBox();
                app.Individual.AddPreviousCheckedDivider();
            });

            $("#gridIndividual").on('click', 'input[type="checkbox"]', function () {
                if ($(this).data("role") === "select-all") {
                    var cb = $(this),          //checkbox that was changed
                        th = cb.closest('th'),      //get parent th
                        col = th.index() + 1;  //get column index.
                    if ($(this).prop("checked")) {
                        $(this).closest('.k-grid').find("td:nth-child(" + col + ") input[type='checkbox']").prop("checked", true);
                    } else {
                        $(this).closest('.k-grid').find("td:nth-child(" + col + ") input[type='checkbox']").prop("checked", false);
                    }
                } else {
                    app.Individual.EvaluateSelectAllCheckBox();
                }
            });
        },
        Details: function () {
            app.Individual.InitProspectiveCommitteeGrid();
            app.UserHome.InitPreviousCommitteeGrid();
            app.UserHome.InitPreviousElectionGrid();
        },
        EvaluateSelectAllCheckBox: function () {
            //detemerine if the select all checkbox should change state
            $('input[data-role="select-all"]').each(function () {
                var cb = $(this),          //checkbox that was changed
                    th = cb.closest('th'),      //get parent th
                    col = th.index() + 1;  //get column index.
                var checkboxCount = $(this).closest('.k-grid').find('tbody').find("td:nth-child(" + col + ") input[type='checkbox']").length;
                if ($(this).closest('.k-grid').find('tbody').find("td:nth-child(" + col + ") input[type='checkbox']:checked").length === checkboxCount) {
                    $(this).prop("checked", true);
                } else {
                    $(this).prop("checked", false);
                }
            });
        },
        AddPreviousCheckedDivider: function () {
            $('.k-grid').find('tbody').find('input[type="checkbox"]:checked:first').closest('tr').addClass('first-previous-checked');
        },
        InitProspectiveCommitteeGrid: function () {
            $("#gridProspectiveCommittee").kendoGrid({
                filterable: {
                    extra: false,
                    operators: {
                        string: {
                            startswith: "Starts with",
                            eq: "Is equal to",
                            neq: "Is not equal to"
                        }
                    }
                },
                toolbar: ["excel"],
                excel: {
                    fileName: "ProspectiveCommittees.xlsx"
                },
                columns: [
                    {
                        field: "Committee",
                        title: "Committee",
                        template: "<a href='#=CommitteeAddress#'>#=Committee#</a>",
                    },
                    {
                        field: "ReasonToAdd",
                        title: "Reason Added"
                    },
                    {
                        field: "AddedDate",
                        title: "Date Added",
                        format: "{0:M/d/yyyy}"
                    },
                    {
                        field: "Notes",
                        title: "Notes"
                    },
                    {
                        field: "Response",
                        title: "Response"
                    },
                    {
                        field: "ResponseDate",
                        title: "Response Date",
                        format: "{0:M/d/yyyy}"
                    },
                    {
                        field: "FacultyDivision",
                        title: "Faculty Division",
                        hidden: true
                    }],
                dataSource: {
                    schema: {
                        model: {
                            fields: {
                                AddedDate: { type: "date" },
                                ResponseDate: { type: "date" }
                            }
                        }
                    }
                },
                noRecords: true,
                scrollable: false,
                width: 100,
                sortable: true,
                columnMenu: true,
                groupable: {
                    messages: {
                        empty: "Drop columns here to group by"
                    }
                }
            });
            app.KendoGrids.InitPersistentGrid("gridProspectiveCommittee", true);
        }
    };
    return myIndividual;
}());